import React, { useState } from "react";
import { track } from "../../../../analytics";
import ReactDOM from "react-dom";
import "./ConnectModal.scss";

const ConnectModal = ({
  isOpen,
  onClose,
  serviceName = "услугу",
  interestedIn = 0,
  apiEndpoint = "/add_deal",
  useServiceName = false,
}) => {
  const [form, setForm] = useState({ name: "", phone: "+992", address: "" });
  const [status, setStatus] = useState("idle");

  if (!isOpen) return null;

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handlePhoneChange = (e) => {
    let val = e.target.value;

    // Не даём удалить +992
    if (!val.startsWith("+992")) {
      val = "+992";
    }

    // Берём только цифры после +992
    const digits = val.slice(4).replace(/\D/g, "");

    // Максимум 9 цифр
    const limited = digits.slice(0, 9);

    setForm((prev) => ({ ...prev, phone: "+992" + limited }));
  };

  // Ровно 9 цифр после +992
  const phoneDigits = form.phone.slice(4).replace(/\D/g, "");
  const phoneValid = phoneDigits.length === 9;
  const isValid = form.name.trim() && phoneValid;

  const handleSubmit = async () => {
    if (!isValid) return;
    setStatus("loading");

    const body = useServiceName
      ? { name: form.name, phone: form.phone, service_name: serviceName }
      : { name: form.name, phone: form.phone, interested_in: interestedIn, address: form.address };

    try {
      const res = await fetch(`https://nets.tj${apiEndpoint}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });
      setStatus(res.ok ? "success" : "error");
      if (res.ok) {
        setForm({ name: "", phone: "+992", address: "" });
        track("lead_submit", { form: serviceName, endpoint: apiEndpoint });
      } else {
        track("lead_error", { form: serviceName, reason: String(res.status) });
      }
    } catch {
      setStatus("error");
      track("lead_error", { form: serviceName, reason: "network" });
    }
  };

  const handleClose = () => {
    setStatus("idle");
    setForm({ name: "", phone: "+992", address: "" });
    onClose();
  };

  const modal = (
    <div className="connect-modal-overlay" onClick={handleClose}>
      <div className="connect-modal" onClick={(e) => e.stopPropagation()}>
        <button className="connect-modal__close" onClick={handleClose}>✕</button>

        {status === "success" ? (
          <div className="connect-modal__success">
            <div className="connect-modal__success-icon">✓</div>
            <h3>Заявка отправлена!</h3>
            <p>Мы свяжемся с вами в ближайшее время.</p>
            <button className="connect-modal__btn" onClick={handleClose}>Закрыть</button>
          </div>
        ) : (
          <>
            <h2 className="connect-modal__title">
              Подключить <span>{serviceName}</span>
            </h2>
            <p className="connect-modal__subtitle">
              Оставьте данные — мы свяжемся и договоримся об удобном времени
            </p>

            <div className="connect-modal__fields">
              <input
                className="connect-modal__input"
                type="text"
                name="name"
                placeholder="Ваше имя"
                value={form.name}
                onChange={handleChange}
              />

              <div className="connect-modal__phone-wrap">
                <span className="connect-modal__phone-flag">🇹🇯</span>
                <input
                  className="connect-modal__input connect-modal__input--phone"
                  type="tel"
                  name="phone"
                  value={form.phone}
                  onChange={handlePhoneChange}
                  placeholder="+992 XXXXXXXXX"
                  maxLength={13} // +992 + 9 цифр = 13 символов
                />
              </div>

              {!useServiceName && (
                <input
                  className="connect-modal__input"
                  type="text"
                  name="address"
                  placeholder="Адрес подключения"
                  value={form.address}
                  onChange={handleChange}
                />
              )}
            </div>

            {status === "error" && (
              <p className="connect-modal__error">Ошибка отправки. Попробуйте снова.</p>
            )}

            <button
              className="connect-modal__btn"
              onClick={handleSubmit}
              disabled={status === "loading" || !isValid}
            >
              {status === "loading" ? "Отправка..." : "Отправить заявку"}
            </button>
          </>
        )}
      </div>
    </div>
  );

  return ReactDOM.createPortal(modal, document.body);
};

export default ConnectModal;